import sm from "./structureMethods-helper";

export default {
  ship_agency_order_filter_data: [
    {
      title: '신청일자',
      type: 'period',
      start: '',
      end: ''
    },
    {
      title: '통합검색',
      type: 'search',
      options: [
        { label: '전체', value: 'all' },
        { label: '이름', value: 'user_full_name' },
        { label: '이메일', value: 'user_email' },
        { label: '회원번호', value: 'user_user_num' },
        { label: '신청번호', value: 'reference_no' },
        { label: '수취인 이름', value: 'info_name' },
      ]
    },
    {
      title: '배송 상태',
      type: 'dropdown',
      key: 'status',
      options: [
        {label: '전체', value: ''},
        {label: '신청접수완료', value: 100},
        {label: '입금대기중', value: 101},
        {label: '입금완료', value: 102},
        {label: '배송완료', value: 103},
        {label: '취소', value: 500},
      ]
    },
    {
      title: '배송 타입',
      type: 'radiobutton',
      key: 'order_type',
      options: [
        {label: '전체', value: ''},
        {label: '기본택배배송', value: 0},
        {label: '분할배송', value: 1},
        {label: '합배송', value: 2},
        {label: '이삿짐', value: 3},
      ]
    }
  ],

  ship_agency_order_table_data: sm.tableData([
    ['checkspot', '', 30],
    ['created_time', '신청일', 120],
    ['order_type_kor', '신청구분', 80],
    ['status_kor', '진행 상태', 80],
    ['reference_no', '신청번호', 120],
    ['user_name', '신청자', 80],
    ['info_name', '수신자명', 80],
    ['email', '이메일', 80],
    ['point', '포인트', 65],
    ['invoice_price', '실제금액(EUR)', 70],
    ['invoice_price_won', '실제금액(KRW)', 70],
    ['invoice_num', '인보이스', 120],
    ['parcel_number', 'HAWB', 80],
    ['insurance_sign', '보상보험', 80],
    ['disclaim', '파손면책', 80]
  ]),

  ship_agency_invoice_filter_data: [
    {
      title: '신청일자',
      type: 'period',
      start: '',
      end: ''
    },
    {
      title: '통합검색',
      type: 'search',
      options: [
        { label: '전체', value: 'all' },
        { label: '이름', value: 'user_full_name' },
        { label: '이메일', value: 'user_email' },
        { label: '회원번호', value: 'user_user_num' },
        { label: '신청번호', value: 'reference_no' },
        { label: '수취인 이름', value: 'info_name' },
      ]
    },
    {
      title: '배송 타입',
      type: 'radiobutton',
      key: 'order_type',
      options: [
        {label: '전체', value: ''},
        {label: '기본택배배송', value: 0},
        {label: '분할배송', value: 1},
        {label: '합배송', value: 2},
        {label: '이삿짐', value: 3},
      ]
    }
  ],

  ship_agency_invoice_table_data: sm.tableData([
    ['check', '', 30],
    ['created_time', '신청일', 120],
    ['order_type_kor', '신청구분', 80],
    ['reference_no', '신청번호', 120],
    ['user_name', '신청자', 80],
    ['email', '이메일', 80],
    ['point', '사용 포인트', 80],
    ['invoice_num', '인보이스', 120],
    ['invoice_price', '실제금액(EUR)', 120],
    ['invoice_price_won', '실제금액(KRW)', 120],
  ]),

  bank_account_filter_data: [
    {
      title: '입금일자',
      type: 'period',
      start: '',
      end: ''
    },
    {
      title: '통합검색',
      type: 'search',
      options: [
        { label: '전체', value: 'all' },
        { label: '입금자명', value: 'name' }
      ]
    },
    {
      title: '매칭',
      type: 'radiobutton',
      key: 'has_invoice',
      options: [
        {label: '전체', value: null},
        {label: '매칭', value: 0},
        {label: '매칭안됨', value: 1}
      ]
    }
  ],
  bank_account_table_data: sm.tableData([
    ['bkcode', '뱅크다 고유번호', 100],
    ['actnumber', '계좌번호', 130],
    ['bkname', '은행명', 80],
    ['account_time', '입금일자', 100],
    ['name', '입금자명', 100],
    ['price', '입금 금액', 100],
    ['bank', '거래은행', 80],
    ['content', '거래방식', 120],
    ['invoice_number', '인보이스', 120]
  ])
}
